import React from "react";
import { FormikProps } from "formik";
import XGSFormInput from "../../../../ui-components/form/input/xgsFormInput";
import XGSFormSelect from "../../../../ui-components/form/select/xgsFormSelect";
import XGSFormTextarea from "../../../../ui-components/form/textarea/xgsFormTextarea";
import { LabelModes } from "../../../../ui-components/molecules/labeled-inputs/labeledInput";
import { countryOptions, statusOptions } from "app/data/terminal-details/models";
import usaStates from "../../../../app/data/common/usaStates";

interface EquipmentFormFieldsProps {
    formikProps: FormikProps<any>;
    isEdit: boolean;
    CardComponent: React.ElementType<{ title: string; hideButtons: boolean; mix?: string; children: React.ReactNode; }>;
}

const EquipmentFormFields = ({ formikProps, isEdit, CardComponent }: EquipmentFormFieldsProps): React.ReactElement => {

    const getOption = (options: any[], value: string | undefined, key: string = 'value') => {
        return options.find((option) => option[key] === value);
    };

    return (
        <div className="equipment-add-edit-section-container">
            <CardComponent title="Basic Information" hideButtons={true}>
                <XGSFormInput
                    type="text"
                    name="equipmentID"
                    labelMode={LabelModes.column}
                    label="Equipment ID (Auto-generated)"
                    placeholder="Equipment ID"
                    disabled
                />
                <XGSFormSelect
                    label="Status"
                    name="status"
                    required
                    options={statusOptions}
                    value={getOption(statusOptions, formikProps.values.status, 'value')}
                    onValueChange={(option) => {
                        formikProps.setFieldValue("status", option?.value ?? "");
                    }}
                    formik={formikProps}
                    labelMode={LabelModes.column}
                />
                <XGSFormInput
                    type="text"
                    name="equipmentName"
                    placeholder="Equipment Name"
                    labelMode={LabelModes.column}
                    label="Equipment Name"
                    required
                />

                <XGSFormInput
                    type="tel"
                    name="phone"
                    placeholder="(000) 000-0000"
                    labelMode={LabelModes.column}
                    label="Phone"
                    required
                />
                <XGSFormInput
                    type="email"
                    name="email"
                    placeholder="abc@abc.com"
                    labelMode={LabelModes.column}
                    label="Email"
                    required
                />
                <div className="card__header">
                    <div className="card__header__content">
                        <div className="equipment-view-container card__title">Address</div>
                    </div>
                </div>
                <XGSFormInput
                    type="text"
                    name="streetAddress"
                    placeholder="Street Address"
                    labelMode={LabelModes.column}
                    label="Street Address"
                    required
                />
                <div className="grid-2col">
                    <XGSFormInput
                        type="text"
                        name="city"
                        placeholder="City"
                        labelMode={LabelModes.column}
                        label="City"
                        required
                    />
                    <XGSFormSelect
                        label="State/Province"
                        name="stateProvince"
                        required={true}
                        options={usaStates}
                        value={getOption(usaStates, formikProps.values.stateProvince, 'value')}
                        onValueChange={(option) => {
                            formikProps.setFieldValue("stateProvince", option?.value ?? "");
                        }}
                        formik={formikProps}
                        labelMode={LabelModes.column}
                    />
                </div>
                <div className="grid-2col">
                    <XGSFormInput
                        type="text"
                        name="zipPostalCode"
                        labelMode={LabelModes.column}
                        label="ZIP/Postal Code"
                        required
                    />
                    <XGSFormSelect
                        label="Country"
                        name="country"
                        required={true}
                        options={countryOptions}
                        value={getOption(countryOptions, formikProps.values.country, 'value')}
                        onValueChange={(option) => {
                            formikProps.setFieldValue("country", option?.value ?? "");
                        }}
                        formik={formikProps}
                        labelMode={LabelModes.column}
                    />
                </div>
            </CardComponent>

            <CardComponent title="Registration & ID" hideButtons={true} mix="registration-id-card">
                <XGSFormInput
                    type="text"
                    name="scacCode"
                    labelMode={LabelModes.column}
                    label="SCAC Code"
                    required
                />
                <XGSFormInput
                    type="text"
                    name="motorEquipmentNo"
                    labelMode={LabelModes.column}
                    label="Motor Equipment (MC) No."
                    required
                />
            </CardComponent>

            <CardComponent title="Insurance Expiration Dates" hideButtons={true} mix="insurance-expiration-dates">
                <div className="grid-2col">
                    <XGSFormInput
                        type="date"
                        name="generalLiabilityDate"
                        labelMode={LabelModes.column}
                        label="General Liability"
                        required
                    />
                    <XGSFormInput
                        type="date"
                        name="autoLiabilityDate"
                        labelMode={LabelModes.column}
                        label="Auto Liability"
                        required
                    />
                </div>
                <div className="grid-2col">
                    <XGSFormInput
                        type="date"
                        name="motorCargoDate"
                        labelMode={LabelModes.column}
                        label="Motor Cargo"
                    />
                    <XGSFormInput
                        type="date"
                        name="workmanCompDate"
                        labelMode={LabelModes.column}
                        label="Workman's Comp"
                    />
                </div>
            </CardComponent>

            {/* Notes Section */}
            <CardComponent title="Notes" hideButtons={true}>
                <XGSFormTextarea
                    name="notes"
                    labelMode={LabelModes.column}
                    placeholder="Enter notes here..."
                />
            </CardComponent>
        </div>
    );
}

export default EquipmentFormFields;